export class Product {
    constructor(data) {
        this.id = data.id;
        this.name = data.name || 'Unnamed Product';
        this.image = data.image || '';
        this.link = data.link || '';
    }

    get hasImage() {
        return !!this.image;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            image: this.image,
            link: this.link,
        };
    }
}
